import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { format } from 'date-fns';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const NotesDialog = ({ isOpen, onClose, patientId, onUpdate }) => {
  const [noteForm, setNoteForm] = useState({
    date: format(new Date(), 'yyyy-MM-dd'),
    content: '',
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');

    try {
      await axios.post(
        `${API}/notes`,
        {
          patient_id: patientId,
          date: noteForm.date,
          content: noteForm.content,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success('Note saved successfully');
      onClose();
      setNoteForm({ date: format(new Date(), 'yyyy-MM-dd'), content: '' });
      onUpdate();
    } catch (error) {
      toast.error('Failed to save note');
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add Note</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4" data-testid="notes-form">
          <div>
            <label className="block text-sm font-medium mb-2">Date</label>
            <input
              data-testid="note-date-input"
              type="date"
              value={noteForm.date}
              onChange={(e) => setNoteForm({ ...noteForm, date: e.target.value })}
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-2">Note</label>
            <textarea
              data-testid="note-content-input"
              value={noteForm.content}
              onChange={(e) => setNoteForm({ ...noteForm, content: e.target.value })}
              rows="6"
              required
              placeholder="Write your note here..."
            />
          </div>
          <button
            data-testid="submit-note-button"
            type="submit"
            className="btn btn-primary w-full"
          >
            Save Note
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default NotesDialog;
